import { createStoreWithMiddlewares, initDefaultSettings } from "./bootstrapFactory";

initDefaultSettings();

const { rootStore, rootHistory } = createStoreWithMiddlewares();
export type RootState = ReturnType<typeof rootStore.getState>;
export type RootDispatch = typeof rootStore.dispatch;

export { rootStore, rootHistory };
